import React from "react";
import {
  FiCalendar,
  FiDownload,
  FiEye,
  FiFileText,
  FiTag,
} from "react-icons/fi";

import Reveal from "../../../components/ui/Reveal";

export default function DocumentCard({ item, onOpen, delay = 0 }) {
  const handleOpen = () => {
    onOpen?.(item);
  };

  return (
    <Reveal delay={delay}>
      <article className="group flex h-full flex-col overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-sm transition duration-300 hover:-translate-y-1 hover:border-[#1277B9]/50 hover:shadow-xl dark:border-slate-800 dark:bg-slate-950">
        <button
          type="button"
          onClick={handleOpen}
          className="relative block aspect-[16/10] overflow-hidden bg-gradient-to-br from-red-50 via-white to-sky-50 text-left dark:from-slate-900 dark:via-slate-950 dark:to-slate-900"
        >
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(220,38,38,0.16),transparent_34%),radial-gradient(circle_at_bottom_right,rgba(18,119,185,0.18),transparent_32%)]" />

          <div className="relative flex h-full flex-col items-center justify-center p-5 text-center">
            <div className="mb-3 flex h-20 w-20 items-center justify-center rounded-3xl bg-red-600 text-white shadow-lg shadow-red-600/20 transition group-hover:scale-105">
              <FiFileText className="h-10 w-10" />
            </div>

            <span className="rounded-full bg-red-100 px-3 py-1 text-xs font-bold uppercase tracking-wide text-red-700 dark:bg-red-500/10 dark:text-red-300">
              PDF
            </span>

            <span className="mt-3 line-clamp-2 max-w-[85%] text-sm font-bold leading-snug text-slate-700 dark:text-slate-200">
              {item.title}
            </span>
          </div>

          <div className="absolute inset-0 flex items-center justify-center bg-slate-950/0 opacity-0 transition group-hover:bg-slate-950/20 group-hover:opacity-100">
            <span className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-sm font-bold text-[#1277B9] shadow">
              <FiEye className="h-4 w-4" />
              Lire le document
            </span>
          </div>
        </button>

        <div className="flex flex-1 flex-col p-5">
          {item.dateLabel && (
            <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-[0.12em] text-slate-400 dark:text-slate-500">
              <FiCalendar className="h-3.5 w-3.5" />
              Publié le {item.dateLabel}
            </p>
          )}

          <h2 className="mt-3 line-clamp-2 text-xl font-bold leading-snug text-slate-950 dark:text-white">
            {item.title}
          </h2>

          <div className="mt-4 flex flex-wrap gap-2">
            {item.category && (
              <span className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-3 py-1 text-xs font-bold text-slate-600 dark:bg-slate-900 dark:text-slate-300">
                <FiTag className="h-3.5 w-3.5" />
                {item.category}
              </span>
            )}

            {item.fileSize && (
              <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-bold text-slate-600 dark:bg-slate-900 dark:text-slate-300">
                {item.fileSize}
              </span>
            )}
          </div>

          {item.tags && (
            <p className="mt-4 line-clamp-2 text-sm leading-7 text-slate-600 dark:text-slate-300">
              {item.tags}
            </p>
          )}

          <div className="mt-auto flex flex-wrap gap-2 pt-5">
            <button
              type="button"
              onClick={handleOpen}
              className="inline-flex min-h-11 flex-1 items-center justify-center gap-2 rounded-2xl bg-[#1277B9] px-4 py-2 text-sm font-bold text-white shadow-sm transition hover:bg-[#0f659d] focus:outline-none focus:ring-2 focus:ring-[#1277B9]/40 sm:flex-none"
            >
              Consulter
              <FiEye className="h-4 w-4" />
            </button>

            {item.url && (
              <a
                href={item.url}
                download={item.downloadName}
                className="inline-flex min-h-11 flex-1 items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-slate-700 transition hover:border-[#1277B9]/50 hover:bg-sky-50 hover:text-[#1277B9] dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100 dark:hover:bg-slate-800 sm:flex-none"
              >
                Télécharger
                <FiDownload className="h-4 w-4" />
              </a>
            )}
          </div>
        </div>
      </article>
    </Reveal>
  );
}